import { Component, Input } from '@angular/core';
import { Panel } from 'src/app/learning-resources/learning-resources.component';

@Component({
    selector: 'app-collapsible-panel',
    templateUrl: './collapsible-panel.component.html',
    styleUrls: ['./collapsible-panel.component.css'],
    standalone: false
})
export class CollapsiblePanelComponent {
  isPanelOpen = false;
  selectAllChecked = false;
  selectAllLabel = 'Select All';

  @Input() domain: Panel;

  // Toggle the panel open or closed
  togglePanel() {
    this.isPanelOpen = !this.isPanelOpen;
  }

  // When "Select All" checkbox is changed
  onSelectAllChange() {
    this.domain.subtasks.forEach((item) => (item.checked = this.domain.allComplete));
  }

  // Update "Select All" checkbox state based on child checkboxes
  onChildCheckboxChange() {
    this.domain.allComplete = this.domain.subtasks.every((item) => item.checked);
  }
}
